import React from "react";
import NavigationBarSkeleton from "./NavigationBarSkeleton";
import FooterBtnSkeleton from "./FooterBtnSkeleton";
import ContentSkeleton from "./ContentSkeleton";

interface Props {
	showNavigationBar?: boolean;
	showFooter?: boolean;
	children?: React.ReactNode;
}
export default function NavigationBarContainerSkeleton({ showNavigationBar, showFooter, children }: Props) {
	return (
		<div className="absolute left-0 top-0 w-full h-full px-4.5 flex flex-col z-10 bg-white dark:bg-dark">
			{showNavigationBar && <NavigationBarSkeleton />}

			<div className="flex-1 overflow-y-hidden">{children}</div>

			{showFooter && <FooterBtnSkeleton />}
		</div>
	);
}
NavigationBarContainerSkeleton.defaultProps = {
	showNavigationBar: true,
	children: <ContentSkeleton />,
};
